import { Icon, Typography } from 'components'
import { Icons, Images, TypographyTypes } from 'interfaces'
import React from 'react'
import { CardFileUploadedProps } from './cardFileUploaded.ttype'

export const CardFileUploaded: React.FC<CardFileUploadedProps> = props => {
	const { nameFile, size, unit, onDelete } = props
	return (
		<div className="flex items-center justify-between border-[1px] border-solid border-gray-4 rounded-lg p-2 w-full shadow-boxPreview">
			<div className="flex items-center gap-2">
				<img src={Images.csvColor} alt="csv" className="w-9 h-9" />
				<div className="flex flex-col">
					<Typography
						title={nameFile || 'N/A'}
						fontLeading="14/24"
						type={TypographyTypes.p}
						className="text-black-1 font-normal text-base"
					/>
					<div className="flex items-center gap-2">
						<Typography
							title={`${size} ${unit ?? ''} •`}
							fontLeading="14/24"
							type={TypographyTypes.p}
							className="text-gray-1 font-normal text-base"
						/>
						<div className="flex flex-row gap-3">
							<Icon
								src={Icons.checkCircleTags}
								fillPath
								className="text-green-500 w-6 h-6"
							/>
							<Typography
								title="Uploaded"
								fontLeading="14/24"
								type={TypographyTypes.p}
								className="text-black-1 font-normal text-base"
							/>
						</div>
					</div>
				</div>
			</div>
			{!!onDelete && (
				<button type="button" onClick={onDelete}>
					<Icon
						src={Icons.delete}
						fillPath
						className="text-black-1 w-6 h-6 "
						pointer
					/>
				</button>
			)}
		</div>
	)
}
